/**
 * Component to render a "cl-section" -- with the title, divider & content in a specific layout --
 * this is here to reduce code duplication and make it easier to change the look & feel of the entire app if desired
 */

export class ClSectionComponent implements angular.IComponentOptions {
    public bindings: any = {
        sectionTitle: '@'
    };

    public controller = ClSectionController;

    public template: string = `
        <section class="cl-section">
            <div class="cl-section-header" layout="row">
                <div ng-if="$ctrl.sectionTitle" class="cl-section-title" md-colors="{color: 'accent'}">
                    <span ng-bind="$ctrl.sectionTitle"></span>
                </div>
                <div flex></div>
                <div ng-transclude="header"></div>
            </div>
            <md-divider md-colors="{color: 'accent'}" ng-if="$ctrl.sectionTitle" layout="row"></md-divider>

            <div layout="column">
                <div ng-transclude="body"></div>
            </div>
        </section>
    `;

    public transclude: any = {
        body: 'clSectionBody',
        header: '?clSectionHeader'
    };
}

// tslint:disable-next-line: max-classes-per-file
export class ClSectionController implements angular.IComponentController {
    public sectionTitle: string;
}
